
import React, { Component } from 'react'
import Modal from 'react-modal'
import Window from '../Window'

Modal.setAppElement(document.body)

const customStyles = {
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(255,255,255, 1)',
    textAlign: 'center',
    minHeight: '40px',
    minWidth: '180px'
  },
  overlay: {
    background: 'rgba(0,0,0, 0.5)',
    zIndex: 1050
  }
}

class Alert extends Component {
  constructor () {
    super()
    this.state = {
      modalIsOpen: false,
      error: '',
      inputValue: '',
      listener: null
    }
    this.openModal = this.openModal.bind(this)
    this.afterOpenModal = this.afterOpenModal.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
  }
  componentDidMount () {
    this.setState({
      listener: Window.addListener('dialogStateChange', () => {
        this.setState({
          modalIsOpen: Window.getDialogState().isOpen
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  afterOpenModal () {
  }
  openModal () {
    this.setState({
      modalIsOpen: true
    })
  }
  closeDialog () {
    Window.closeDialog()
  }

  onOKButtonClicked () {
    if (Window.getDialogState().onOKButtonClicked) {
      Window.getDialogState().onOKButtonClicked()
    } else {
      Window.closeDialog()
    }
  }

  onYesButtonClicked () {
    if (Window.getDialogState().onYesButtonClicked) {
      Window.getDialogState().onYesButtonClicked()
    } else {
      Window.closeDialog()
    }
  }

  onNoButtonClicked () {
    if (Window.getDialogState().onNoButtonClicked) {
      Window.getDialogState().onNoButtonClicked()
    } else {
      Window.closeDialog()
    }
  }

  onSendButtonClicked () {
    if (Window.getDialogState().onSendButtonClicked) {
      const inputValue = this.state.inputValue.trim()
      if (inputValue === '') {
        this.setState({
          error: '入力は必須です'
        })
        return false
      } else {
        const error = Window.getDialogState().onSendButtonClicked(this.state.inputValue)
        this.setState({
          error: error
        })
      }
    } else {
      Window.closeDialog()
    }
  }

  onCancelButtonClicked () {
    if (Window.getDialogState().onCancelButtonClicked) {
      Window.getDialogState().onCancelButtonClicked()
    } else {
      Window.closeDialog()
    }
  }

  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }

  renderOKButton () {
    return (
      <button className='btn btn-small btn-default' style={{width: '80px', fontWeight: 'bold'}} onClick={this.onOKButtonClicked.bind(this)}>OK</button>
    )
  }
  renderYesNoButtons () {
    return (
      <div>
        <button className='btn btn-small btn-primary' style={{width: '80px', fontWeight: 'bold', marginRight: '5px'}} onClick={this.onYesButtonClicked.bind(this)}>はい</button>
        <button className='btn btn-small btn-default' style={{width: '80px', fontWeight: 'bold', marginRight: '5px'}} onClick={this.onNoButtonClicked.bind(this)}>いいえ</button>
      </div>
    )
  }
  renderSendCancelButtons () {
    return (
      <div>
        <button className='btn btn-small btn-primary' style={{width: '80px', fontWeight: 'bold', marginRight: '5px'}} onClick={this.onSendButtonClicked.bind(this)}>はい</button>
        <button className='btn btn-small btn-default' style={{width: '80px', fontWeight: 'bold', marginRight: '5px'}} onClick={this.onCancelButtonClicked.bind(this)}>いいえ</button>
      </div>
    )
  }
  renderButtons () {
    const type = Window.getDialogState().type
    switch (type) {
      case 'alert':
        return this.renderOKButton()
      case 'confirm':
        return this.renderYesNoButtons()
      case 'prompt':
        return this.renderSendCancelButtons()
      default:
        break
    }
  }
  render () {
    const message = Window.getDialogState().message
    const buttons = this.renderButtons()
    const inputArea = (Window.getDialogState().type === 'prompt') ? <input value={this.state.inputValue} onChange={(e) => this.setState({inputValue: e.target.value})} /> : []
    const errorMessage = (this.state.error) ? <p style={{color: 'red', padding: '10px'}}>{this.state.error}</p> : []
    return (
      <div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeDialog}
          shouldCloseOnOverlayClick={false}
          style={customStyles}
          contentLabel='Example Modal'
        >
          <p>{this.nl2br(message)}</p>
          {errorMessage}
          {inputArea}
          <div className='text-center' style={{marginTop: '15px'}}>
            {buttons}
          </div>
        </Modal>
      </div>
    )
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/common/component/Dialog.js